"use client";
import { useState } from "react";
import NewsLatterBox from "./NewsLatterBox";
import emailjs from "emailjs-com";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      const text = await response.text();
      console.log('🧾 Raw Response:', text);
  
      let data;
      try {
        data = JSON.parse(text);
      } catch (err) {
        console.error('❌ Failed to parse JSON from server:', err);
        throw new Error('Invalid response from server');
      }
  
      if (!response.ok) {
        throw new Error(data?.error || 'Something went wrong while sending the email.');
      }
  
      toast.success('Message sent successfully!');
      setFormData({ name: '', email: '', message: '' });
  
    } catch (error) {
      console.error('❌ Form Submission Error:', error);
      toast.error(error.message || 'Error sending message');
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <section id="contact" className="overflow-hidden py-16 md:py-20 lg:py-28 bg-white pt-36">
      <div className="container">
        <div className="-mx-4 flex flex-wrap">
          <div className="w-full px-4 lg:w-7/12 xl:w-8/12">
            <div className="mb-12 rounded-lg bg-white px-8 py-11 shadow-lg sm:p-[55px] lg:mb-5 lg:px-8 xl:p-[55px] border-2 border-[#136207]/20">
              <h2 className="mb-3 text-3xl font-bold font-orbitron text-[#136207] text-center">
                Contact Our Support Team
              </h2>
              <p className="mb-8 mt-4 text-lg font-poppins text-gray-600 text-center">
                We're here to help! Reach out to us with any questions or concerns.
              </p>
              
              <form onSubmit={handleSubmit} className="space-y-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium font-poppins text-[#136207] mb-2">
                      Your Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      className="w-full rounded-lg border border-[#136207]/30 px-4 py-3 font-poppins text-gray-700 focus:ring-2 focus:ring-[#136207] focus:border-transparent"
                      required
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium font-poppins text-[#136207] mb-2">
                      Your Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      className="w-full rounded-lg border border-[#136207]/30 px-4 py-3 font-poppins text-gray-700 focus:ring-2 focus:ring-[#136207] focus:border-transparent"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium font-poppins text-[#136207] mb-2">
                    Your Message
                  </label>
                  <textarea
                    name="message"
                    rows={5}
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="How can we help you?"
                    className="w-full rounded-lg border border-[#136207]/30 px-4 py-3 font-poppins text-gray-700 focus:ring-2 focus:ring-[#136207] focus:border-transparent"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full rounded-lg bg-[#136207] px-6 py-4 font-poppins font-medium text-white transition-colors hover:bg-[#0f4d06] focus:outline-none focus:ring-2 focus:ring-[#136207] focus:ring-offset-2"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </form>
            </div>
          </div>

          <div className="w-full px-4 lg:w-5/12 xl:w-4/12">
            <NewsLatterBox />
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastClassName="font-poppins"
      />
    </section>
  );
};

export default Contact;